var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 5H19","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5 12H19","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5 19H19","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Bars.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Bars;

Bars.default = Bars;
